import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Phase 10B 2050 SectionGrid — tighter default gap (16px) and a stagger
 * entrance applied via the `.stagger` class so children fade in.
 */
const colClasses = {
  1: "grid-cols-1",
  2: "grid-cols-1 md:grid-cols-2",
  3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
};

const SectionGrid = React.forwardRef(
  ({ className, cols = 2, stagger = true, children, ...props }, ref) => {
    const key = typeof cols === "string" ? parseInt(cols, 10) : cols;
    const layout = colClasses[key] || colClasses[2];
    return (
      <div
        ref={ref}
        className={cn("grid gap-4", layout, stagger && "stagger", className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);
SectionGrid.displayName = "SectionGrid";

export { SectionGrid };
